module.exports = __webpack_public_path__ + "img/successful-payment.e9f6cd23.svg";